import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function differentFromInitialRole(
  initialRole: string | undefined,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    return control.value === initialRole ? { sameAsInitialRole: true } : null;
  };
}
